<app-empty-sidebar-icon />
No items
